export default "__VITE_ASSET__BId8NGfO__"